<template>

  <div class="widget-content-promotion" :class="{ 'image-only': isImageOnly }" v-if="promotion">
    <br>

    <div class="promotion-image" v-if="settings.showImage && imageAsset" :style="imageStyle"></div>

    <div class="title" v-if="settings.showTitle || settings.showSubtitle || (settings.showLabels !== false && badgeLabels(promotion).length)">
      <div class="title-inner">
        <dmb-widget-styled-text v-if="settings.showTitle" :style="settings.titleTextStyle">{{
            promotion.title
          }}
        </dmb-widget-styled-text>
        <dmb-label-badges v-if="settings.showLabels !== false && badgeLabels(promotion).length && settings.labelPosition !== 'BELOW'"
                          :labels="badgeLabels(promotion)" :text-style="settings.labelTextStyle || settings.subtitleTextStyle" :image-size="settings.labelImageSize"></dmb-label-badges>
      </div>

      <template v-if="settings.showSubtitle">
        <dmb-widget-styled-text v-for="(line, i) in subtitleLines(promotion)" :key="i" :style="settings.subtitleTextStyle">{{ line }}
        </dmb-widget-styled-text>
      </template>

      <dmb-label-badges v-if="settings.showLabels !== false && badgeLabels(promotion).length && settings.labelPosition === 'BELOW'"
                        :labels="badgeLabels(promotion)" :text-style="settings.labelTextStyle || settings.subtitleTextStyle" :image-size="settings.labelImageSize"></dmb-label-badges>
    </div>

    <div class="price" v-if="settings.showPriceRegular || settings.showPricePromo">

      <dmb-widget-styled-text v-if="settings.showPriceRegular" :style="settings.priceTextStyle">
        <dmb-price :currency="widget.settings.showCurrency" :mode="settings.priceMode"
                   :price="promotion.priceRegular"/>
      </dmb-widget-styled-text>

      <dmb-widget-styled-text v-if="settings.showPricePromo" :style="settings.pricePromoTextStyle">
        <dmb-price :currency="widget.settings.showCurrency" :mode="settings.priceMode"
                   :price="promotion.pricePromo"/>
      </dmb-widget-styled-text>
    </div>

  </div>
  <div v-else-if="freeze" class="widget-content-placeholder">{{
      $t('app.widgets.widgetContentPromotion.noPromotion')
    }}
  </div>

</template>

<script>

import {Vue, Options} from 'vue-class-component'

import WidgetStyledText from '../WidgetStyledText.vue';
import Price from '../Price.vue';

import PromotionState from '../../enum/PromotionState';
import WidgetSettingsPromotionMode from '../../enum/WidgetSettingsPromotionMode';
import Asset from "../ui/Asset.vue";
import LabelBadges from './LabelBadges.vue';
import {subtitleLines} from '../../util/labelDisplay';

export default Options({
  name: 'dmb-widget-content-promotion',
  components: {
    [WidgetStyledText.name]: WidgetStyledText,
    [Asset.name]: Asset,
    [Price.name]: Price,
    [LabelBadges.name]: LabelBadges,
  },
  props: {
    widget: Object,
    freeze: Boolean
  }
})(
    class WidgetContentPromotion extends Vue {

      get settings() {

        return this.widget.settings;
      }

      get promotion() {

        const mode = this.widget.settings.mode;
        let promo = null;

        if (mode === WidgetSettingsPromotionMode.RANDOM) {

          promo = this.$store.state.promotions.randomPromotion;
        } else if (mode === WidgetSettingsPromotionMode.SPECIFIC && this.widget.settings.promotionId) {

          promo = this.$store.getters.getPromotion(this.widget.settings.promotionId);
        }

        if (!promo) {
          return null;
        }

        if (!this.freeze && promo.state !== PromotionState.AVAILABLE) {
          return null;
        }

        return promo;
      }

      get showStyle() {

        return this.$store.state.style.showStyle;
      }

      subtitleLines(promotion) {

        return subtitleLines(promotion);
      }

      badgeLabels(promotion) {

        return promotion.labels || [];
      }


      get imageAsset() {

        return this.promotion.imageAssetId ? this.$store.getters.getAsset(this.promotion.imageAssetId) : null;
      }

      get imageStyle() {
        if (!this.imageAsset) {
          return {};
        }

        const style = {
          backgroundImage: `url(${this.imageAsset.url})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        };

        if (this.settings.contentMode === 'CONTAIN') {
          style.backgroundSize = 'contain';
        } else {
          style.backgroundSize = 'cover';
        }

        return style;
      }

      get isImageOnly() {
        const st = this.settings;

        return st.showImage && !st.showTitle && !st.showSubtitle && !st.showPricePromo && !st.showPriceRegular;
      }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentPromotion.scss" lang="scss"></style>
